import { useEffect, useState, useRef } from 'react';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

/* eslint-disable react-hooks/exhaustive-deps */
var useMountEffect = function useMountEffect(callback) {
  return useEffect(callback, []);
};

var useIsMounted = function useIsMounted() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  useMountEffect(function () {
    setIsMounted(true);
  });
  return isMounted;
};

/* istanbul ignore file */

// This is useful when you want to fire an effect only after you've mounted.
// Useful for example if you have memoized objects you want to export from
// custom hooks but only when they change after the initial construction
var useUpdateEffect = function useUpdateEffect(effect, deps) {
  var mounted = useRef(false);
  useEffect(function () {
    if (mounted.current) {
      return effect();
    }
    mounted.current = true;
  }, deps);
};

// https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/
function useTimeout(callback, delay) {
  var timeoutRef = useRef(null);
  var savedCallback = useRef(callback);
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    var tick = function tick() {
      return savedCallback.current();
    };
    if (typeof delay === 'number') {
      timeoutRef.current = window.setTimeout(tick, delay);
      return function () {
        return window.clearTimeout(timeoutRef.current);
      };
    }
  }, [delay]);
  return timeoutRef;
}

var usePrevious = function usePrevious(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var ref = useRef(defaultValue);
  // Store current value in ref
  useEffect(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
};

function useInterval(callback, interval) {
  var intervalRef = useRef(null);
  var savedCallback = useRef();
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    var handler = function handler() {
      return savedCallback.current.apply(savedCallback, arguments);
    };
    if (interval) {
      intervalRef.current = setInterval(handler, interval);
      return function () {
        return clearInterval(intervalRef.current);
      };
    }
  }, [interval]);
  return intervalRef;
}

function useOnce(initializer) {
  var value = useState(initializer)[0];
  return value;
}

export { useInterval, useIsMounted, useMountEffect, useOnce, usePrevious, useTimeout, useUpdateEffect };
//# sourceMappingURL=hooks.js.map
